import type { Client, Listing, ReportPdfOptions } from '~/models'
import ReportComparisonPdf from './comparison'
import ReportFlyersPdf from './flyers'
import ReportSummaryPdf from './summary'

export type ReportPdfSwitchProps = {
  client: Client
  title: string
  listings: Listing[]
  pdfOptions: ReportPdfOptions
}

export default function ReportPdfSwitch({ ...props }: ReportPdfSwitchProps) {
  if (props.pdfOptions.type === 'flyers') {
    return <ReportFlyersPdf {...props} />
  } else if (props.pdfOptions.type === 'summary') {
    return <ReportSummaryPdf {...props} />
  } else if (props.pdfOptions.type === 'comparison') {
    return <ReportComparisonPdf {...props} />
  }
  return null
}
